import React, { useContext } from 'react';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { inventoryContext } from '../InventoryContext';
import Moment from 'react-moment';
import theme from 'assets';

let Results = () => {
    let service = useContext(inventoryContext);

    return (
        <Grid container marginTop={theme.spacing(1)}>
            <Grid item xs={12}>
                {service.inventory && service.inventory.sku && service.inventory.inventories &&
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Warehouse</TableCell>
                                    <TableCell align='center'>Quantity</TableCell>
                                    <TableCell>Last updated on</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {service.inventory.inventories.length > 0 &&
                                    service.inventory.inventories
                                        .map((inv, idx) =>
                                            <TableRow key={idx}>
                                                <TableCell>{inv.warehouse}</TableCell>
                                                <TableCell align='center'>{inv.quantity}</TableCell>
                                                <TableCell>
                                                    <Moment date={inv.lastUpdatedOn} format='LLL' />
                                                </TableCell>
                                            </TableRow>
                                        )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
                {(!service.inventory || !service.inventory.sku) &&
                    <Typography variant='subtitle2'>No results found</Typography>
                }
            </Grid>
        </Grid >
    );
}

export default Results;